export default "__VITE_ASSET__BurpkH$___"